// DEPRECATED. Use jv.simple-select.directive or jv.AjaxSelect
/**
 * @author varun
 */
/**
 * 	Look at scope literal for inheritance.
 * 
 *	Using this directive you need three attributes.
 *		i) 	'what-to-watch' :  (Array) REQUIRED -> 	This will be used as the data for the select2. 
 *			eg: [{'data':'hello world', 'some_id_name':'1235Xh8'},...]
 *		 
 *		ii)	'what-to-change': (String) REQUIRED ->	What key should be changed in scope to reflect the change in select2.
 *			you need to specify a scope variable here. Everytime user makes a selection it will set that scope variable as the returned object.
 *			eg. In above case it will set the value as  {'data':'hello world', 'id':'1235Xh8'}
 *			 
 *		iii)'what-is-text'  : (String) REQUIRED ->	This will be used as the 'key' for displaying text in the object provided by 'what-to-watch'. (select2 uses 'text' as the key by default)
 *			eg. For above case it will be 'data'
 *			
 *		iv) 'what-is-id': (String) OPTIONAL: -> default is 'id'. you can specify your own id key for the select2.
 *			eg. For above case it will be 'some_id_name'
 *				
 *		v)	'set-to-disable': (Boolean)OPTIONAL: -> if true it will set the select2 in disabled state. Default is enabled.
 *		 
 *		NOTE: if you are setting the default value for the select2 then 'what-is-id' is required. 
 *
 * 		eg. <div jv-select2 what-to-watch="" what-to-change="" what-is-text="" what-is-id="" ></div>
 * 
 * ***********************
 * DEPENDENCY
 * ***********************
 * i) Add this at the bottom of the page before you include 'jv.Select2.js' file
 * 		
 * 		<script src="/__assets__/lib/select2/select2-3.4.5/select2.js" type='text/javascript'></script>
 * 
 * ii) Add this at the top of your page after your page css. 
 * 		IMPORTANT: Make sure that it is a 'jsp' page, otherwise 'c:url' will not work.
 * 		
 * 		<link rel="stylesheet" href="/__assets__/lib/select2/select2-3.4.5/select2.css" type="text/css" media="all" />
 * 
 */
angular.module("jv.Common.Directives.Select2",[])
	.directive('jvCommonSelect2', function($timeout, $filter){
		
		var linker = function(scope, element, attribute){
			var hiddenField = angular.element("<input style='"+ attribute['style'] +"' type=\"hidden\" />");
			element.append(hiddenField);
			var firstRun = true;
			function buildResetObj() {
				var resetObj = { };
				if(angular.isDefined(attribute.jvPlaceholder)) {
					var possibles = $filter("filter")(scope.whatToWatch, function(value) {
						return value[attribute.whatIsText] === attribute.jvPlaceholder;
					});
					if (possibles.length === 1) {
						resetObj = possibles[0];
					} else {
						resetObj[attribute.whatIsId] = "";
						resetObj[attribute.whatIsText] = attribute.jvPlaceholder;
					}
				}else {
					if(firstRun && (scope.whatToChange != null) && angular.isDefined(scope.whatToChange)){
						resetObj = scope.whatToChange;
					} else {
						resetObj = scope.whatToWatch[0];
					}
					firstRun = false;
				}
				return resetObj;
			}
			function renderSelect2(){
				// If there is another way you want to show the text.
				function format(item){
					return item[attribute['whatIsText']];
				}
				
				var options = {};
				if (angular.isDefined(attribute.jvAllowClear)) {
					options.allowClear = !!attribute.jvAllowClear;
				}
				if (angular.isDefined(attribute.jvPlaceholder)) {
					options.placeholder = attribute.jvPlaceholder;
				}

				options.formatSelection = format;
				options.formatResult = format;
				options.id = function(state){
					return state[attribute['whatIsId']] || state['id'];
				};
				options.data = {
					results: scope['whatToWatch'],
					text: attribute['whatIsText']
				};
				options.initSelection = function(element, callback) {
					if(angular.isObject(scope.whatToChange)) {
						callback(scope.whatToChange);
					} else {
						callback(scope.whatToWatch[0]);
					}
				};

				$(hiddenField).select2(options).on('change', function( event ){
						scope.$apply(function(scope){
							if(event.val === "" || angular.isUndefined(scope.whatToChange) || scope.whatToChange==null) {
								scope.whatToChange = buildResetObj( );
							} else {
								for(var i = 0, j=scope['whatToWatch'].length; i<j;i++){
									if( scope['whatToWatch'][i][   attribute['whatIsId']  ] == event.val){
										scope['whatToChange'] = scope['whatToWatch'][i];
										break;
									}
								}
							}
						});
					});
				$timeout(function(){
					var newVal = buildResetObj();
					$(hiddenField).val(newVal);

					$(hiddenField).trigger('change');
				}, 300);
					
				if(scope['setToDisabled'] === 'true'){
					$(hiddenField).select2("disable");
				}
			}
			
			scope.$watch('whatToWatch', function(newValue, oldValue){
				if(angular.isDefined(newValue) && newValue.length>0){
					renderSelect2();
				}
			});			
		};
		
		return{
			restrict: 'A',
			scope:{
				"whatToWatch":"=whatToWatch",
				"whatToChange": "=whatToChange",
				"whatIsText":"@whatIsText",
				"whatIsId": "@whatIsId",
				"setToDisabled": "@"
			},
			link: linker
		}
	})